export default __webpack_public_path__ + "static/media/207-malaysia.43898cea.svg";